import React from "react";
import fullLogo from "../assets/credita-cge-logo-full.png";
import symbolLogo from "../assets/credita-cge-logo-symbol.png";

const sizeMap = {
  sm: {
    symbol: "h-9 w-9",
    full: "h-10 max-w-[190px]",
  },
  md: {
    symbol: "h-11 w-11",
    full: "h-12 max-w-[250px]",
  },
  lg: {
    symbol: "h-14 w-14",
    full: "h-20 max-w-[460px]",
  },
};

export default function BrandLogo({ compact = false, size = "md", className = "" }) {
  const classes = sizeMap[size] || sizeMap.md;
  const src = compact ? symbolLogo : fullLogo;
  const imgClass = compact ? classes.symbol : classes.full;

  return (
    <img
      src={src}
      alt="Credita CGE - Consultoria & Gestão Empresarial"
      className={`${imgClass} w-auto object-contain ${className}`.trim()}
    />
  );
}
